var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return Object.keys(_vm.filterObjects).length !== 0
    ? _c("div", { staticClass: "search-filter-delete" }, [
        _c(
          "div",
          {
            staticClass:
              "form-wrapper form-wrapper--no-asterisk form-wrapper--margin-2",
          },
          [
            _vm.showTitle
              ? _c("div", { staticClass: "filter-label" }, [
                  _c("i", {
                    staticClass: "fas fa-trash-alt d-none d-sm-block",
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "col-form-label" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("messages_nl.search-form.removeFilterTitle")
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "input-with-icon" }, [
              _c(
                "div",
                { staticClass: "remove-filter-container" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "remove-all",
                      attrs: { id: "removeFilter_0" },
                      on: {
                        click: function ($event) {
                          _vm.removeAllDeletableFilters()
                          _vm.$emit("clicked")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("messages_nl.search-form.removeFilter")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filterObjects, function (value, key) {
                    return _c(
                      "div",
                      {
                        key: key,
                        staticClass: "remove-single-filter boxed-widget--clean",
                        on: {
                          click: function ($event) {
                            _vm.removeDeletableFilter(key)
                            _vm.$emit("clicked")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-times" }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(value))]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }